import dayjs from 'dayjs';

function buildPullSheetExportBasename(dateRange, extension) {
  const start = dateRange?.[0]?.format('YYYY-MM-DD');
  const end = dateRange?.[1]?.format('YYYY-MM-DD');
  const generated = dayjs().format('YYYY-MM-DD');

  if (start && end) {
    if (start === end) {
      return `pull-sheet_${start}_${generated}.${extension}`;
    }
    return `pull-sheet_${start}_to_${end}_${generated}.${extension}`;
  }

  return `pull-sheet_${generated}.${extension}`;
}

export function buildPullSheetCsvFilename(dateRange) {
  return buildPullSheetExportBasename(dateRange, 'csv');
}

export function buildPullSheetPdfFilename(dateRange) {
  return buildPullSheetExportBasename(dateRange, 'pdf');
}

export function formatCurrency(value) {
  if (value == null || value === '') {
    return '—';
  }
  const amount = Number(value);
  if (Number.isNaN(amount)) {
    return value;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}
